import BpkBannerAlert, {
  ALERT_TYPES,
} from '@skyscanner/backpack-web/bpk-component-banner-alert';

const createMarkup = (markup: string) => ({ __html: markup });

/* eslint-disable react/no-danger */
const FooterBlurb = ({ disclaimer }: { disclaimer: string }) => (
  <BpkBannerAlert
    message={<span dangerouslySetInnerHTML={createMarkup(disclaimer)} />}
    type={ALERT_TYPES.NEUTRAL}
  />
);
/* eslint-enable react/no-danger */

export default FooterBlurb;
